import React, { useState } from "react";
import EAAlert from "../../../../shared/EAAlert";
import { pluralZajec } from "../../../../shared/TimeSlot/utils";
import { Ticket } from "../../../../../models/Ticket";
import CatchUpLessonsModal from "./CatchUpLessonsModal";
import getCatchUpLessonsTickets from "./getCatchUpLessonsTickets";
import "./CatchUpLessons.scss";

interface IProps {
  sortedTickets: Ticket[];
  refreshTickets: () => void;
}

const CatchUpLessonsBanner: React.FC<IProps> = ({ sortedTickets, refreshTickets }) => {
  const catchUpTickets = getCatchUpLessonsTickets(sortedTickets);
  const [activeTrhId, setActiveTrhId] = useState<string | null>(null);

  if (catchUpTickets.length === 0) {
    return null;
  }

  const activeTicketInfo = catchUpTickets.find((info) => info.ticket.trhId === activeTrhId);

  return (
    <div className="catch-up-lessons-banner">
      {catchUpTickets.map(({ ticket, count }) => {
        const ticketSuffix = catchUpTickets.length > 1 && ticket.name ? ` (${ticket.name})` : "";
        return (
          <EAAlert
            key={ticket.trhId}
            type="warning"
            message={`Masz ${count} ${pluralZajec(count)} do odrobienia${ticketSuffix}.`}
            buttonText="Odrób lekcje"
            onButtonClick={() => setActiveTrhId(ticket.trhId)}
          />
        );
      })}

      {activeTicketInfo && (
        <CatchUpLessonsModal
          isOpen
          ticket={activeTicketInfo.ticket}
          onClose={() => setActiveTrhId(null)}
          onBooked={refreshTickets}
        />
      )}
    </div>
  );
};

export default CatchUpLessonsBanner;
